import httpClient from '@xto10x/core/lib/httpClient';

const jiraIntegrationApi = {
  getAllConnections: () => httpClient.get('/v1/jira'),
  createConnection: requestBody => httpClient.post('/v1/jira', requestBody),
  updateConnection: (jiraId, connection_name) =>
    httpClient.put(`/v1/jira/${jiraId}`, { connection_name }),
  deleteConnection: jiraId => httpClient.delete(`/v1/jira/${jiraId}`),
  getAllIssues: (jiraId, query = null) =>
    httpClient.get(`/v1/jira/${jiraId}/issues`, { query }),
  getAllLabels: jiraId => httpClient.get(`/v1/jira/${jiraId}/labels`),
  getAllProjects: jiraId => httpClient.get(`/v1/jira/${jiraId}/projects`),
  trackProgress: (requestBody, jiraId) =>
    httpClient.post(`/v1/jira/${jiraId}/track-progress`, requestBody),
  updateTracker: (requestBody, jiraId) =>
    httpClient.put(`/v1/jira/${jiraId}/track-progress`, requestBody),
  deleteTracker: requestBody =>
    httpClient.delete('/v1/jira/delete-progress-tracker', requestBody),
  getObjectiveProgress: requestBody =>
    httpClient.post('/v1/jira/get-progress', requestBody),
  updateObjectiveProgress: requestBody =>
    httpClient.post('/v1/jira/update-progress', requestBody)
};

export default jiraIntegrationApi;
